const prefix = 'purchases';

export const CHECKOUT = `${prefix}/CHECKOUT`;

export const ALLOCATION_PENDING = `${prefix}/ALLOCATION_PENDING`;
export const ALLOCATION_SUCCEEDED = `${prefix}/ALLOCATION_SUCCEEDED`;
export const ALLOCATION_FAILED = `${prefix}/ALLOCATION_FAILED`;
